// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GetCardLayout_cardWrapper__HTgoC {
  border-radius: 1.8rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1), 0 2px 7px 0 rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/component/common/getCardLayout/GetCardLayout.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,0EAAA;AACF","sourcesContent":[".cardWrapper {\n  border-radius: 1.8rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1), 0 2px 7px 0 rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardWrapper": `GetCardLayout_cardWrapper__HTgoC`
};
export default ___CSS_LOADER_EXPORT___;
